import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue"
import PopupBase from "@/vue/common/popupBase.vue"

// Props
interface Props {
	overlayColor: string
	overlayMaxOpacity: number
	top?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicPopup',
  props: {
    overlayColor: {},
    overlayMaxOpacity: {},
    top: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

// Refs
const isPopupOpen = ref<boolean>(false)

function openPopup(): void {
	isPopupOpen.value = true
}

function closePopup(): void {
	isPopupOpen.value = false
}

// Exposing functions using defineExpose
__expose({
	openPopup,
	closePopup,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupBase, {
    open: isPopupOpen.value,
    onClosePopup: closePopup,
    "overlay-color": props.overlayColor,
    "overlay-max-opacity": props.overlayMaxOpacity,
    styleTop: '25%'
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["open", "overlay-color", "overlay-max-opacity"]))
}
}

})